<template>
  <div class="dealer-index">
    <div class="dealer-name">
      {{ dealerName }}
    </div>
    <PassportLevel :dealerId="dealerId" />
    <UserRank :dealerId="dealerId" />
    <MonthChart :dealerId="dealerId" />
    <div @click="$router.back()" class="back-btn" v-show="userType != '1'">返回</div>
  </div>
</template>

<script>
import UserRank from './rank/userRank.vue'
import MonthChart from './monthChart.vue'
import PassportLevel from './passportLevel.vue'
import { getDealerDetail } from '@/api/common/index.js'
export default {
  components: { MonthChart, UserRank, PassportLevel },
  name: 'dealerIndex',
  data() {
    return {
      userType: localStorage.getItem('userType'),
      dealerId: '',
      dealerName: '', //经销商名称
      companyId: null, //经销商集团id设为null
    }
  },
  methods: {
    getDetail() {
      getDealerDetail({
        dealerId: this.dealerId,
      }).then((res) => {
        this.dealerName = res.data.name
      })
    },
},
  created() {},
  mounted() {
    this.dealerId = this.$route.query.id || JSON.parse(localStorage.getItem('user')).dealerId
    this.getDetail()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.dealer-index {
  .dealer-name {
    font-size: 15px;
    padding-left: 10px;
    font-weight: 500;
    height: 38px;
    line-height: 38px;
    color: #fff;
    background: url('../assets/img/title-black.png') center no-repeat;
    background-size: 100%;
    margin-bottom: 10px;
  }
}
</style>
